module.exports = __webpack_public_path__ + "img/thumbnail_RedKangaroo_j_normal.aacccc65.png";